// About the bride
export const interestsData = {
  Creative: [
    { label: "Writing", icon: "✍️" },
    { label: "Cooking", icon: "🍳" },
    { label: "Singing", icon: "🎤" },
    { label: "Playing instrument", icon: "🎸" },
    { label: "Poetry", icon: "📝" },
    { label: "Dancing", icon: "💃" },
    { label: "Photography", icon: "📷" },
    { label: "Acting", icon: "🎭" },
  ],
  Fun: [
    { label: "Movies", icon: "🎬" },
    { label: "Musics", icon: "🎶" },
    { label: "Traveling", icon: "✈️" },
    { label: "Biking", icon: "🚴" },
    { label: "Gaming", icon: "🎮" },
    { label: "Theatre & Events", icon: "🎟️" },
    { label: "Social media", icon: "📱" },
    { label: "Reading", icon: "📖" },
    { label: "Stand-up Comedy", icon: "🎙️" },
    { label: "Board Games", icon: "🎲" },
    { label: "Amusement Parks", icon: "🎡" },
    { label: "Karaoke", icon: "🎤" },
    { label: "Picnics", icon: "🧺" },
    { label: "Camping", icon: "🏕️" },
    { label: "Escape Rooms", icon: "🧩" },
    { label: "Watching Sports", icon: "🏟️" },
  ],
  "Fitness & Sports": [
    { label: "Gym workouts", icon: "🏋️" },
    { label: "Yoga", icon: "🧘" },
    { label: "Running", icon: "🏃" },
    { label: "Cycling", icon: "🚴" },
    { label: "Swimming", icon: "🏊" },
    { label: "Football", icon: "⚽" },
    { label: "Cricket", icon: "🏏" },
    { label: "Badminton", icon: "🏸" },
  ],
};

export const personalityData = {
  "Identity aspects": [
    { label: "Ambitious", icon: "🚀" },
    { label: "Loyal", icon: "🤝" },
    { label: "Funny", icon: "😄" },
    { label: "Conservative", icon: "🏛️" },
    { label: "Community-focused", icon: "🏘️" },
    { label: "Patient", icon: "🧘‍♂️" },
    { label: "Energetic", icon: "⚡" },
    { label: "Positive", icon: "🌞" },
  ],
  "Passions and goals": [
    { label: "Bookworm", icon: "📚" },
    { label: "Dancer", icon: "💃" },
    { label: "Gamer", icon: "🎮" },
    { label: "Artisitic", icon: "🎨" },
    { label: "Cooking enthusiast", icon: "👨‍🍳" },
    { label: "Music lover", icon: "🎧" },
    { label: "Cultural explorer", icon: "🌍" },
  ],
  "Lifestyle & Values": [
    { label: "Minimalist", icon: "🧺" },
    { label: "Environmentally conscious", icon: "🌱" },
    { label: "Family-oriented", icon: "👨‍👩‍👧‍👦" },
    { label: "Spiritual", icon: "🕉️" },
    { label: "Health-conscious", icon: "🥗" },
    { label: "Adventurous", icon: "🧗" },
    { label: "Animal lover", icon: "🐾" },
    { label: "Tech-savvy", icon: "💻" },
    { label: "Introvert", icon: "📘" },
    { label: "Extrovert", icon: "📣" },
    { label: "Work-life balancer", icon: "⚖️" },
    { label: "Independent", icon: "🦅" },
    { label: "Open-minded", icon: "🧠" },
  ],
};

// Physical and marital details
export const selectBodyHeight = Array.from({ length: 121 }, (_, i) => {
  const value = 80 + i;
  return {
    label: `${value} cm`,
    value: value,
  };
});

export const selectBodyWeight = Array.from({ length: 121 }, (_, i) => {
  const value = 30 + i;
  return {
    label: `${value} kg`,
    value: value,
  };
});

// Career details
export const selectEmployment = [
  { label: "Part time", value: 1 },
  { label: "Full time", value: 2 },
  { label: "Not Working", value: 3 },
];

//radio button
export const orphan = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const drinking = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
  { label: "Occasionally", value: 3 },
];

export const smoking = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
  { label: "Occasionally", value: 3 },
];
//4

export const getAgeOptions = (gender = "male") => {
  const startAge = gender?.toLowerCase() === "female" ? 21 : 18;
  const maxAge = 70;

  return Array.from({ length: maxAge - startAge + 1 }, (_, i) => {
    const age = i + startAge;
    return { value: `${age}`, label: `${age} years` };
  });
};

export const preferanceBodyHeight = [
  { label: "Below 150 cm", value: "<150" },
  { label: "150 cm", value: "150" },
  { label: "155 cm", value: "155" },
  { label: "160 cm", value: "160" },
  { label: "165 cm", value: "165" },
  { label: "170 cm", value: "170" },
  { label: "175 cm", value: "175" },
  { label: "180 cm", value: "180" },
  { label: "Above 180 cm", value: ">180" },
];

export const preferanceBodyWeight = [
  { label: "Below 50 kg", value: "<50" },
  { label: "50 kg", value: "50" },
  { label: "55 kg", value: "55" },
  { label: "60 kg", value: "60" },
  { label: "65 kg", value: "65" },
  { label: "70 kg", value: "70" },
  { label: "75 kg", value: "75" },
  { label: "80 kg", value: "80" },
  { label: "Above 80 kg", value: ">80" },
];

//5

export const uploadMenu = [
  { label: "Remove", key: "1" },
  { label: "Set as primary photo", key: "2" },
];
